import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Layout from "./Layout/Layout";
import { Suspense } from "react";
import Enroll from "./pages/Enroll";
import ClassRoom from "./pages/ClassRoom";
import Session from "./pages/Session";
// import Profile from "./pages/StudentsProfile"; // This line will be removed
import Auth from "./pages/Auth";
import TeacherClassRoom from "./pages/TeacherClassRoom";
import AppLayout from "./pages/AdminDashboard";
import NotFound from "./pages/NotFound";
import StudentProfile from "./pages/StudentProfile"; // Your local change
import React from "react"; // From the remote changes
import TeachersProfile from "./pages/TeachersProfile";
import { ToastContainer } from "react-toastify"; // Import ToastContainer
import Middleware from "./components/Middleware/Middleware";
import CourseDetailPage from "./pages/CourseDetailPage";
import SessionMiddleware from "./components/Session/SessionMiddleware";
const Room = React.lazy(() => import("./pages/Room")); // From the remote changes

function App() {
	return (
		<BrowserRouter>
			<Suspense fallback={<div>Loading..</div>}>
				<ToastContainer />
				<Routes>
					{/* Routes using the Layout component */}
					<Route path="/" element={<Home />} />
					<Route element={<Layout />}>
						<Route path="/enroll">
							<Route
								index
								element={
									<Middleware requiredRole={["student"]}>
										<Enroll />
									</Middleware>
								}
							/>
							<Route
								path=":courseId"
								element={
									<Middleware requiredRole={["student"]}>
										<CourseDetailPage />
									</Middleware>
								}
							/>
							{/* From remote changes */}
						</Route>
						<Route path="/classroom">
							<Route index element={<ClassRoom />} />
							<Route
								path=":classroomId"
								element={
									<SessionMiddleware>
										<Room />
									</SessionMiddleware>
								}
							/>
							{/* From remote changes */}
						</Route>
						<Route path="/teacherClassRoom">
							<Route index element={<TeacherClassRoom />} />
							<Route
								path=":LiveDetailId"
								element={
									<SessionMiddleware>
										<Session />
									</SessionMiddleware>
								}
							/>
						</Route>
						<Route
							path="/teachersProfile"
							element={
								<Middleware requiredRole={["teacher"]}>
									<TeachersProfile />
								</Middleware>
							}
						/>
						<Route
							path="/studentProfile"
							element={
								<Middleware requiredRole={["student"]}>
									<StudentProfile />
								</Middleware>
							}
						/>{" "}
						{/* Your local change */}
					</Route>

					{/* Routes that do not use the Layout component */}
					<Route path="/auth" element={<Auth />} />

					<Route
						path="/admin/*"
						element={
							<Middleware requiredRole={["admin"]}>
								<AppLayout />
							</Middleware>
						}
					/>

					{/* Catch-all route for undefined paths */}
					<Route path="*" element={<NotFound />} />
				</Routes>
			</Suspense>
		</BrowserRouter>
	);
}

export default App;
